import mixplanelTrack from '~/mixpanel-service';
import emitEvent from '~/utilities/snowplow/emitEvent';

// MIXPANEL - to be removed when we switch to snowplow
export const DIALOG_OPEN_MIXPANEL = 'v2.popup-viewed';
export const USER_INFORMATION_STEP_MIXPANEL = 'v2.your-information';
export const COMPANY_INFORMATION_STEP_MIXPANEL = 'v2.company-and-settings';
export const PLAN_SELECT_STEP_MIXPANEL = 'v2.price-plan-viewed';
export const PLAN_SELECT_STEP_SELECTED_SUBSCRIPTION_MIXPANEL = 'v2.selected-plan.subscription';
export const PLAN_SELECT_STEP_CONTINUE_WITH_SUBSCRIPTION_MIXPANEL = 'v2.selected-plan.subscription-next';
export const PLAN_SELECT_STEP_SELECTED_PER_USE_MIXPANEL = 'v2.selected-plan.regular';
export const PLAN_SELECT_STEP_CONTINUE_WITH_PER_USE_MIXPANEL = 'v2.selected-plan.regular-next';
export const SUCCESSFUL_ONBOARDING_MIXPANEL = 'v2.economic-signup-done';

export const trackSmartPayOnboardingMixpanel = (action: string): void => {
    mixplanelTrack('smartpay.onboarding.', action);
};

// SNOWPLOW
export const DIALOG_OPEN = 'iglu:com.e-conomic/smartpay_onboarding_open_dialog/jsonschema/1-0-1';
export const USER_INFORMATION_STEP = 'iglu:com.e-conomic/smartpay_onboarding_your_information_step/jsonschema/1-0-1';
export const COMPANY_INFORMATION_STEP = 'iglu:com.e-conomic/smartpay_onboarding_company_and_settings/jsonschema/1-0-1';
export const PLAN_SELECT_STEP = 'iglu:com.e-conomic/smartpay_onboarding_plan_select_step/jsonschema/1-0-2';
export const PLAN_SELECT_STEP_SELECTED_OPTION = 'iglu:com.e-conomic/smartpay_onboarding_selected_plan/jsonschema/1-0-1';
export const PLAN_SELECT_STEP_CONTINUE = 'iglu:com.e-conomic/smartpay_onboarding_selected_plan_continue/jsonschema/1-0-1';
export const SUCCESSFUL_ONBOARDING = 'iglu:com.e-conomic/smartpay_onboarding_successful_onboarding/jsonschema/1-0-1';
export const ONBOARDING_ERROR = 'iglu:com.e-conomic/smartpay_onboarding_onboarding_error/jsonschema/1-0-1';

export const trackSmartPayOnboarding = (action: string, data?: object): void => {
    emitEvent(action, data);
};

export const getPlanNameForSnowplowEvent = (planId = 1): string => (planId === 2 ? 'Subscription' : 'Pay per use');
